import gql from 'graphql-tag'

export const TEAMMEMBER_QUERY = gql`
query {
  teanMembers {
    data {
      id
      attributes {
        firstName
        lastName
        slug
        position
        knownFor
        Description
        Image {
          data {
            attributes {
              url
              alternativeText
            }
          }
        }
      }
    }
  }
}`;
